import { render, staticRenderFns } from "./Anwesenheitsstatistik.vue?vue&type=template&id=335945da&"
import script from "./Anwesenheitsstatistik.vue?vue&type=script&lang=js&"
export * from "./Anwesenheitsstatistik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports